/**
 * Created by orion on 18.03.17.
 */
import angular from 'angular';
import adminNotification from './admin_notification_directive';
angular.module('mmApp.admin_notification', [])
    .directive('adminNotification', adminNotification);

export default 'mmApp.admin_notification'